module.exports = __webpack_public_path__ + "assets/img/bp_d_i_16.e8139e56.jpg";